import { render, staticRenderFns } from "./LandingContentDesktop.vue?vue&type=template&id=68048622&scoped=true&"
import script from "./LandingContentDesktop.vue?vue&type=script&lang=js&"
export * from "./LandingContentDesktop.vue?vue&type=script&lang=js&"
import style0 from "./LandingContentDesktop.vue?vue&type=style&index=0&id=68048622&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68048622",
  null
  
)

export default component.exports